/* start - flights_split_bounds_us */
import React, { ReactNode } from "react";
import { FLIGHT_DETAILS_ROUTE_PATH, Route } from "./routes";
import { Redirect, useParams, useRouteMatch } from "react-router-dom";
import useGetSearchResultsBound from "../hooks/useGetSearchResultsBound";
import { useSelector } from "react-redux";
import { getSearch } from "../store/search/selectors";
import { FLIGHT_DETAILS_INBOUND_ROUTE_PATH, FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH } from "@flights/constants";
import { useSplitBoundsCondition } from "../utils/experiments/funnel/flights_split_bounds_us";

type Props = {
  route: Route;
  children: ReactNode;
};

const BoundsRedirect = ({ children, route }: Props) => {
  const { isSplitBounds } = useSplitBoundsCondition();
  const search = useSelector(getSearch);
  const bound = useGetSearchResultsBound();
  const params = useParams<{ airports?: string; outboundToken?: string }>();
  /* -- Unfourtunately this is the only way to properly get the :id from here -- */
  const flightDetails = useRouteMatch({ path: FLIGHT_DETAILS_ROUTE_PATH, exact: true });
  const flightDetailsOutbound = useRouteMatch({ path: FLIGHT_DETAILS_OUTBOUND_ROUTE_PATH, exact: true });
  const flightDetailsInbound = useRouteMatch({ path: FLIGHT_DETAILS_INBOUND_ROUTE_PATH, exact: true });
  const fdParams: undefined | { id?: string } =
    flightDetails?.params || flightDetailsOutbound?.params || flightDetailsInbound?.params;
  const id = fdParams?.id;
  /* -- */
  const locationSearch = window.location.search;

  if (process.env.BUILD_TARGET === "server") return children;

  // Note for "id && id !== bound":
  // Since routes fall through, id and bound might be the same value
  // if the bounds' route does not match.

  // -- Split bounds is ENABLED --
  if (isSplitBounds) {
    // Landing on regular flight details
    if ((route.name === "flightdetails" || route.name === "searchresults") && id && id !== bound) {
      return <Redirect to={`/flights/${params.airports}/outbound/${id}/${locationSearch}`} />;
    }

    // Landing on regular search results
    if (route.name === "searchresults") {
      return <Redirect to={`/flights/${params.airports}/outbound/${locationSearch}`} />;
    }
  }

  // -- Split bounds is DISABLED --
  if ((search.type !== "ROUNDTRIP" && bound) || (!isSplitBounds && bound)) {
    const isAnyBoundsPage =
      route.name === "flightdetails-outbound" ||
      route.name === "flightdetails-inbound" ||
      route.name === "searchresults-outbound" ||
      route.name === "searchresults-inbound";
    // Landing on bounds flight details
    if (isAnyBoundsPage && id && id !== bound) {
      return <Redirect to={`/flights/${params.airports}/${id}/${locationSearch}`} />;
    }

    // Landing on bounds search results
    if (route.name === "searchresults-outbound" || route.name === "searchresults-inbound") {
      return <Redirect to={`/flights/${params.airports}/${locationSearch}`} />;
    }
  }

  return children;
};

export default BoundsRedirect;
/* end - flights_split_bounds_us */
